import styled from 'styled-components';

const InfiniteScrollAppendStyle = styled.section`
	--imageBlockGap: var(--sp3x);
	--imageHeight: 139%;
	--scaleValueX: 1.02;
	--scaleValueY: 1.025;

	--textInfoBlockPad: var(--sp5x);
	--textInfoInnerBlockPad: var(--sp2x);

	--scrollYCol1DefaultSize: 130%;
	--scrollYCol2DefaultSize: 210%;
	--scrollYCol3DefaultSize: 170%;
	--scrollYColAnimSize: -412%;
	--scrollYSecondSize: 85%;
	--scrollYFinallySize: -20%;

	position: relative;
	height: 100vh;
	overflow-y: auto;

	/* //! Hide scrollbar */
	-ms-overflow-style: none;
	scrollbar-width: none;

	&::-webkit-scrollbar {
		display: none;
	}

	.infinite-inner-wrapper {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: calc(var(--imageBlockGap) + var(--sp1x)) var(--imageBlockGap);
		padding-top: var(--headerFixedHeight);
	}

	.element-block {
		will-change: transform;
	}

	.element-inner-block {
		position: relative;

		.before-layer,
		.after-layer {
			position: absolute;
			left: 0;
			bottom: 0;
			width: 100%;
			pointer-events: none;

			opacity: 0;
			will-change: opacity;

			z-index: 1;
		}

		.before-layer {
			height: 50%;
			background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, transparent 100%);
		}

		.after-layer {
			height: 100%;
			background: rgba(0, 0, 0, 0.2);
		}
	}

	.element-link-block {
		display: block;
		transform-origin: center;

		will-change: transform;
	}

	.text-info-block {
		position: absolute;
		inset: 0;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		padding: var(--textInfoBlockPad);
	}

	.text-info-inner-block {
		display: flex;
		flex-direction: column;
		gap: var(--textInfoInnerBlockPad);
	}

	.image-inner-block {
		overflow: hidden;
		isolation: isolate;

		.image-cont {
			/* --proportion: var(--imageHeight); */
			--proportion: 0;

			display: flex;

			img {
				position: relative !important;
				aspect-ratio: 3/4;
			}

			transform: scale(1.05);
			will-change: transform;
		}
	}

	.position-wrapper {
		position: absolute;
		top: 0;
		left: var(--core_contPaddingLR);
		width: calc(100% - (var(--core_contPaddingLR) * 2));
	}

	.anim-wrapper {
		.element-block {
			&:nth-child(3n + 1) {
				transform: translateY(var(--scrollYCol1DefaultSize));
			}
			&:nth-child(3n + 2) {
				transform: translateY(var(--scrollYCol2DefaultSize));
			}
			&:nth-child(3n) {
				transform: translateY(var(--scrollYCol3DefaultSize));
			}
		}

		&.anim-active {
			.element-block {
				&:nth-child(3n + 1) {
					animation: scrollYAnimCol1 3s forwards;
				}
				&:nth-child(3n + 2) {
					animation: scrollYAnimCol2 3s forwards;
				}
				&:nth-child(3n) {
					animation: scrollYAnimCol3 3s forwards;
				}
			}
		}

		&.finally-anim {
			animation: scrollYFinallyAnim 3s forwards;
		}
	}

	.initial-wrapper {
		transform: translateY(100%);

		.element-block {
			.featured-title {
				position: relative;

				transform: translateY(100%);
				will-change: transform;

				z-index: 3;
			}

			.featured-location {
				position: relative;

				opacity: 0;
				will-change: opacity;

				z-index: 3;
			}
		}

		&.initial-active {
			animation: scrollY 3s forwards;
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--imageHeight: 142%;

		--scaleValueX: 1.022;
		--scaleValueY: 1.033;

		--textInfoBlockPad: var(--sp4x);
		--textInfoInnerBlockPad: var(--sp1-5x);

		--scrollYColAnimSize: -415%;
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--imageHeight: 142%;

		--scaleValueX: 1.025;
		--scaleValueY: 1.04;

		--textInfoBlockPad: var(--sp3x);
		--textInfoInnerBlockPad: var(--sp0-5x);

		--scrollYColAnimSize: -419%;

		@media only screen and (max-width: 1800px) {
			--scrollYColAnimSize: -417%;
		}
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--imageBlockGap: var(--sp2-5x);
		--imageHeight: 141.5%;

		--scaleValueX: 1.025;
		--scaleValueY: 1.04;

		--textInfoBlockPad: var(--sp2-5x);
		--textInfoInnerBlockPad: var(--sp0-5x);

		--scrollYColAnimSize: -420%;
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--imageBlockGap: var(--sp2-5x);
		--imageHeight: 139.5%;

		--scrollYColAnimSize: -420%;
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--imageBlockGap: var(--sp1x);
		--imageHeight: 139%;

		--scaleValueX: 1;
		--scaleValueY: 1;

		--scrollYColAnimSize: -419%;

		.infinite-inner-wrapper {
			gap: var(--sp2-5x);
		}
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--scrollYCol1DefaultSize: 220%;
		--scrollYCol2DefaultSize: 300%;
		--scrollYCol3DefaultSize: 260%;
		--scrollYColAnimSize: -625%;
		--scrollYSecondSize: 85%;

		.infinite-inner-wrapper {
			grid-template-columns: repeat(2, 1fr);
		}

		.anim-wrapper {
			.element-block {
				&:nth-child(3n + 1),
				&:nth-child(3n + 2),
				&:nth-child(3n) {
					transform: unset;
				}

				&:nth-child(2n + 1) {
					transform: translateY(var(--scrollYCol1DefaultSize));
				}
				&:nth-child(2n) {
					transform: translateY(var(--scrollYCol2DefaultSize));
				}
			}

			&.anim-active {
				.element-block {
					&:nth-child(3n + 1),
					&:nth-child(3n + 2),
					&:nth-child(3n) {
						animation: unset;
					}

					&:nth-child(2n + 1) {
						animation: scrollYAnimCol1 3s forwards;
					}
					&:nth-child(2n) {
						animation: scrollYAnimCol2 3s forwards;
					}
				}
			}
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--scrollYColAnimSize: -631%;

		.infinite-inner-wrapper {
			gap: var(--sp1-5x);
		}

		@media only screen and (max-width: 375px) {
			--scrollYColAnimSize: -632%;
		}
	}

	/* //! Animations */
	/* //! For Second Anim */
	@keyframes scrollY {
		from {
			transform: translateY(var(--scrollYSecondSize));
		}

		to {
			transform: translateY(0%);
		}
	}

	/* //! For First Anim */
	@keyframes scrollYAnimCol1 {
		from {
			transform: translateY(var(--scrollYCol1DefaultSize));
		}

		to {
			transform: translateY(var(--scrollYColAnimSize));
		}
	}

	@keyframes scrollYAnimCol2 {
		from {
			transform: translateY(var(--scrollYCol2DefaultSize));
		}

		to {
			transform: translateY(var(--scrollYColAnimSize));
		}
	}

	@keyframes scrollYAnimCol3 {
		from {
			transform: translateY(var(--scrollYCol3DefaultSize));
		}

		to {
			transform: translateY(var(--scrollYColAnimSize));
		}
	}

	@keyframes scrollYFinallyAnim {
		from {
			transform: translateY(0%);
		}

		to {
			transform: translateY(var(--scrollYFinallySize));
		}
	}
`;

export default InfiniteScrollAppendStyle;
